import { FC, ReactElement } from 'react';

import styles from './Headline.module.scss';

type HeadlineProps = {
  title: string | ReactElement;
  subTitle: string;
  addClass?: string[];
  sm?: boolean;
};

export const Headline: FC<HeadlineProps> = ({ title, subTitle, addClass = [], sm = false }) => {
  return (
    <header className={[styles.headline, sm ? styles.headlineSm : '', ...addClass].join(' ')}>
      <h2 className={styles.title}>{title}</h2>
      <span className={styles.subTitle}>{subTitle}</span>
    </header>
  );
};
